var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('button-back'),_vm._v(" "),_c('state-logo'),_vm._v(" "),(_vm.$route.name === 'contact')?_c('button-next'):_c('contact-button'),_vm._v(" "),_c('main-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }